import { slideToggle } from "./helpers/plainSlide.js";

// Accordian.js


const accordionOpeners = document.querySelectorAll(".js-accordion-trigger");

if (accordionOpeners && accordionOpeners.length) {
  accordionOpeners.forEach(item => {
    item.addEventListener("click", function(e) {
      e.preventDefault();

      // Show the sliding animation and slide the content
      slideToggle(this.nextElementSibling, 160);

      // Toggle active class
      if (this.classList.contains("accordion-trigger--active")) {
        this.classList.remove("accordion-trigger--active");
      } else {
        this.classList.add("accordion-trigger--active");
      }
    });
  });
}
